function Dashboard() {
  return (
    <h1>Rendering Dashboard</h1>
  );
}

export default Dashboard